import { Button, PageState } from '@deepdive-ui';
import { Component, type ErrorInfo, type ReactNode } from 'react';

import { reportError } from '@/services/errorReporting';

/** Last-resort boundary above the router (route errors are handled by `RouteError`). */
export class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    reportError(error, { boundary: 'app', componentStack: info.componentStack });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <PageState
        fullScreen
        role="alert"
        title="Something went wrong"
        description="DeepDive hit an unexpected error."
        actions={
          <Button hierarchy="primary" onClick={() => window.location.reload()}>
            Reload
          </Button>
        }
      />
    );
  }
}
